import { Component, ElementRef, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { CommonService } from 'src/app/Service/Common.service';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { IMsgAttachmentsModel, IMsgDocumentAttachmentModel, IMsgElementInputModel } from 'src/app/ViewModel/CommunicationModel';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { Align } from '@progress/kendo-angular-popup';
import { ISignatureOutputModel } from 'src/app/ViewModel/CommunicationModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';

import { debounceTime, exhaustMap, filter, scan, startWith, switchMap, tap } from 'rxjs/operators';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { formatDate } from '@angular/common';
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { ITransmittalTemplateModel, ITransmittalMemberModel, ITransmittalReceiverDetails, ITransmittalDistributionViewModel, IReceiverDetails, ITransmittalGroupViewModel } from 'src/app/ViewModel/TransmittalTemplateModel';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatChipList } from '@angular/material/chips';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { ITransmittalDocumentDetails, ITransmittalDocViewModel, ITransmittalSerialNoInputModel, ITransmittalMsgInputModel, ITransmittalMsgReceiverInput, ITransmittalGroupMemberInput, ITransmittalMsgDocumentInput, ITransmittalDocumentInput, ITransmittalDocumentCopyInput, ITransmittalDocumentElementDetails, ITransmittalElementSLNoInputModel, IReceiverInput, IDistributionMemberDetails, ITransmittalDocumentMsgDetails, ITransmittalDocumentCopyDetails, ITransmittalDocumentElementInput, ITransmittalMailDetails, ITransmittalViewDocDetails, ITransmittalDocumentAttachmentModel, ITransmittalSignedDocumentsModel } from 'src/app/ViewModel/TransmittalModel';
import { TransmittalMsgService } from 'src/app/Service/transmittal/transmittal.service';
import { TransmittalTemplateComponent } from '../transmittal-template/transmittal-template.component';
import { TransmittalViewComponent } from '../transmittal-view/trasnsmittal-view.component';
import { Module } from 'src/app/Service/element-details.data.service';
import { groupBy, map, sortBy } from 'lodash';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { ScheduleDocumentMailListComponent } from '../../engineering-schedule/schedule-document-mail-list/schedule-document-mail-list.component';
import { IDocumentMailInputModel } from 'src/app/ViewModel/DocumentModel';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { DocumentService } from 'src/app/Service/document/document.service';
import { DocumentViewGridComponent } from '../document-grid/document-view-grid/document-view-grid.component';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { RespondWorkflowListModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { Observable, BehaviorSubject, Subject, Subscription } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';

const matches = (el: {
  matches: any; msMatchesSelector: any;
}, selector: string) => (el.matches || el.msMatchesSelector).call(el, selector);

const createFormGroup = (dataItem: ITransmittalDocViewModel) => new FormGroup({
  'quantity': new FormControl(dataItem.quantity, [Validators.required, Validators.pattern('^[0-9]*$')]),
  'category': new FormControl(dataItem.category, [Validators.required]),
  'type': new FormControl(dataItem.type, [Validators.required]),
  'remarks': new FormControl(dataItem.remarks)
});

const createFromGroupDist = (dataItem: ITransmittalGroupViewModel) => new FormGroup({
  'quantity': new FormControl(dataItem.quantity, [Validators.required, Validators.pattern('^[0-9]*$')]),
  'category': new FormControl(dataItem.category, [Validators.required]),
  'type': new FormControl(dataItem.type, [Validators.required]),
  'remarks': new FormControl(dataItem.remarks)
});

@Component({
  selector: 'app-transmittal-creation',
  templateUrl: './transmittal-creation.component.html',
  styleUrls: ['./transmittal-creation.component.css']
})
export class CreateTransmittalComponent implements OnInit, OnDestroy {
  ShowTransmittalTemplate: boolean = false;
  transmittalData!: TransmittalTemplateComponent;
  private transmittalViewComponent!: TransmittalViewComponent;
  @ViewChild('docGrid') docGrid!: GridComponent;
  @ViewChild('distGrid') distGrid!: GridComponent;
  @ViewChild("docSetForm") dynamicForm!: DynamicFormComponent;
  @ViewChild('transmittalViewComponent') set content(content: TransmittalViewComponent) {
    if (!!content) { // initially setter gets called with undefined
      this.transmittalViewComponent = content;
    }
  }
  @ViewChild(GridComponent)
  private grid!: GridComponent;
  panelOpenState = true;
  public inputType: any;
  public selectedMessages!: any[];
  public transmittalFormat!: string;
  public numFormat!: string;
  public isShowSerialNo: boolean = true;
  serialNoLength: number = 5;
  public readonly!: boolean;
  public DistrowIndex!: number;
  public reciviedDoc: any[] = [];
  public responseRequired!: string;
  public projectId!: number;
  public selectedData: any[] = [];
  public groupId!: number;
  public memberId: number | undefined;
  public canManualNo: boolean = false;
  public msgNo!: string;
  public getSelected_Type: any[] = [];
  public _getSelected_Type: any[] = [];
  public messageNo!: string;
  public DocSelectedCategory: number | null | undefined;
  public DocSelectedType: number[] | undefined | null;
  public MessageId!: number;
  public autoSerialNo!: string;
  public isMessageValid!: boolean;
  isWorkflow!: boolean;
  editedRowIndex!: number | undefined;
  editedRowIndexDist!: number;
  public formGroup!: FormGroup | undefined;
  formGroupDist!: FormGroup | any;
  public projectElements: IProjectElementsOutput[] = [];
  public numElements: Map<string,
    string> = new Map<string,
      string>();
  public elementInp: IMsgElementInputModel[] | (ITransmittalElementSLNoInputModel | undefined)[] = [];
  public elementInput: IMsgElementInputModel[] = [];
  public mailType: string = '';
  categoryList: any[] = [];
  copyTypeList: any[] = [];
  templateDetails: ITransmittalTemplateModel[] = [];
  distributionList: any[] = [];
  documentViewList: ITransmittalDocViewModel[] = [];
  documentUpdateList: any[] = [];
  currentEditGroupViewModel!: ITransmittalGroupViewModel | any;
  signedDocuments: ITransmittalDocumentAttachmentModel[] = [];
  template_Id: string | number | null = null;
  selectedCategory!: number | any;
  selectedRemarks!: string | undefined;
  selectedTransmittalType: number[] = [];
  selectedFrom!: number | null;
  selectedTo!: number | null;
  WorkflowDocument!: boolean;
  separatorKeysCodes: number[] = [ENTER, SPACE, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  multiple = false;
  doc_Id: number | null = null;
  masterMembers: ITransmittalMemberModel[] = [];
  masterMemberIds!: number[];
  filteredMembers!: Observable<ITransmittalMemberModel[]>;
  ccFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  fromFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  ccMembers: ITransmittalMemberModel[] = [];
  @ViewChild('ccInput') ccInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ccauto') matCcAutoComplete!: MatAutocomplete;
  @ViewChild('ccChipList') ccChipList!: MatChipList;
  ccfilter$!: Observable<any> | undefined;
  private _nextPage$ = new Subject();
  templateFormat: string = '';
  elementsConfig: FieldConfig[] = [];
  mailSubject: string = '';
  IsShowAttachmentList = false;
  isShowbulkSave = false;
  projectName!: string;
  /*Signature*/
  IsShowPopup = false;
  public IsDisabled!: boolean;
  public anchorElementPopup: any;
  public anchorAlignCenter: Align = {
    horizontal: 'center',
    vertical: 'bottom'
  };
  public margin = {
    horizontal: -15,
    vertical: 10
  };
  public signatureList: ISignatureOutputModel[] = [];
  public documentList: any[] = [];
  public messageList: any[] = [];
  public membersList: any[] | undefined = [];
  mailFrom: string = '';
  public fromList: any[] = [];
  mailTo: string = '';
  public toList: any[] = [];
  mailCC: string = '';
  public ccList: any[] = [];
  mailBCC: string = '';
  public bccList: any[] = [];
  selected_Category: any;
  selected_Type!: number[];
  messageGroupForm!: FormGroup;
  transmittalForm!: FormGroup;
  messageContentForm!: FormGroup;
  public isRevisedDateInvalid!: boolean;
  public datevalue = new Date(this.getDateFormat());
  public RespondOn: string | null = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
  public dtnList: RespondWorkflowListModel[] = [];
  public pendingWFList: any[] = [];
  public is_Send_Mail: boolean = true;
  componentRef: any;
  public CurrentProjectDetails!: ProjectViewModel;
  public is_Show_Attachment_In_DTN!: boolean;
  public task_id_list!: string;
  public enableFullscreen: boolean = false;
  UnsubscribeArray: Subscription[] = [];
  attachmentsList: IMsgDocumentAttachmentModel[] = [];

  constructor(
    private _projService: ProjectInfoService,
    public communicationService: CommunicationService,
    public commonService: CommonService,
    public memberService: ExternalMemberService,
    public elementLinkService: ElementLinkService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateTransmittalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    private _transmittalService: TransmittalService,
    private _formBuilder: FormBuilder,
    private _transmittalMsgService: TransmittalMsgService,
    private _scheduleDocService: ScheduleDocumentService,
    private _fileService: FileService,
  ) { }

  ngOnInit() {
    this.selectedTransmittalType = null;
    this.inputType = this.data['inputType'];
    this.doc_Id = this.data["doc_Id"];
    this.dtnList = this.data["selectedList"];
    if (this.dtnList == undefined)
      this.dtnList = [];
    this.transmittalFormat = 'Transmittal';
    this.numFormat = 'Auto';
    this.readonly = true;
    this.IsDisabled = true;
    this.responseRequired = 'No';
    this.createTransmittalGroupForm();
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.CurrentProjectDetails = this.commonService.getCurrentProjectDetails();
    if (this.CurrentProjectDetails && this.CurrentProjectDetails.doc_Number_Format) {
      this.numFormat = this.CurrentProjectDetails.doc_Number_Format;
      this.onNumFormatChange(this.numFormat);
    }
    this.callMemberRoleandFeature();
    this.getSerialNoLength();
    this.getElementDetails("Message Category");
    this.getElementDetails("Copy Type");
    this.getTransmittalDetails()
    let _getProjectMembers = this._transmittalService.getProjectMembers().subscribe((res: ProjectMemberModel[]) => {
      this.masterMembers = res.map(x => {
        let transmittalMember: ITransmittalMemberModel = {
          memberId: x.memberId,
          memberName: x.memberName,
          memberShortName: x.memberShortName,
          eMailId: x.eMailId,
          mobileNo: x.mobileNo,
          staffPSNo: x.staffPSNo,
          address: x.address
        };
        return transmittalMember;
      });
      this.masterMemberIds = this.masterMembers.map(x => x.memberId);
      this.ccfilter$ = this.createSerachFilter('ccMembersCtrl');
      this.filterMembers();
    });
    this.getDynamicForm();
    this.getSignatureList();
    this.getProjectName();
    this.getMembers();

    this.messageGroupForm.controls['txtNoOfDays'].setValue(0);
    let _getWorkflowPendingDocuments = this._scheduleDocService.GetWorkflowPendingDocuments({
      project_Id: this.projectId,
      group_Id: this.groupId
    }).subscribe((res: any[]) => {
      this.pendingWFList = res;
      if (this.dtnList.length > 0) {
        this.documentList = this.dtnList.map(x => {
          let docInput: any = {
            docId: x.documentId,
            documentNo: x.documentNumber,
            title: x.documentTitle,
            revision: x.revisionNo,
            authorisedByName: x.authorizedByName,
            createdByName: x.assignedToName,
            schedule_Type: x.schedule_Type,
            is_Show_DTN_Attachment_Task_Id: x.is_Show_DTN_Attachment_Task_Id
          };
          return docInput;
        });
      } else {
        if (this.doc_Id != null && this.doc_Id != undefined) {
          let docInput = {
            docId: this.data['doc_Id'],
            revision: this.data['revision_No'],
            documentNo: this.data['doc_No'],
            title: this.data['doc_Title'],
            authorisedByName: "",
            createdByName: ""
          };
          this.documentList.push(docInput);
          this.documentList = res.map(x => {
            let docInput: any = {
              docId: x.doc_Id,
              documentNo: x.doc_No,
              title: x.doc_Title,
              revision: x.revision_No,
              authorisedByName: x.authorized_By,
              createdByName: x.created_By
            };
            return docInput;
          })
          this.documentList = this.documentList.filter(x => x.docId == this.doc_Id);
        }
      }
      this.GetWorkFlowStatus();
      this.documentViewList = this.documentList.map(x => {
        let category: any = null;
        let type: any = null;
        let remarks: any = "";
        let quantity: any = null;
        let docViewModel: ITransmittalDocViewModel = {
          doc_Id: x.docId,
          revision_No: x.revision,
          title: x.title,
          document_No: x.documentNo,
          authorized_By: x.authorisedByName,
          category: category,
          type: type,
          remarks: remarks,
          quantity: quantity,
          scheduleType: x.schedule_Type,
          isAttachemtUploded: x.schedule_Type == 3 ? true : false,
          task_Id: x.is_Show_DTN_Attachment_Task_Id
        };
        if (x.schedule_Type == 3 || (x.is_Show_DTN_Attachment_Task_Id != undefined && x.is_Show_DTN_Attachment_Task_Id != null))
          return this.validateAttachment(docViewModel, x.is_Show_DTN_Attachment_Task_Id)
        else
          return this.validateAttachment(docViewModel);
      })
      this.documentUpdateList = this.documentViewList;
    });

    if (this.inputType == 'dtnPreparation') {
      this.is_Send_Mail = false;
      this.isWorkflow = true;
    }

    this.UnsubscribeArray.push(_getProjectMembers, _getWorkflowPendingDocuments)
  }

  private onDocumentClick(e: any): void {
    if (!matches(e.target, '#docGrid tbody *, #docGrid .k-grid-toolbar .k-button')) {
      if (e.target.id != 'attachmentRemarks' && e.target.id != 'attachmentEdit') {
        this.UpdateRowData(null);
      }
    }
  }


  async callMemberRoleandFeature() {
    let _getPorjectMemberRoles = this.commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe((result: any[]) => { });
    let _getProjectMemberFeatures = await this.commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((result1: any[]) => {
      this.canManualNo = result1.some(data => data.feature_Desc == 'Manual No');
      if (!this.canManualNo && this.numFormat == 'Manual')
        this.numFormat = 'Auto';
    });
    this.UnsubscribeArray.push(_getPorjectMemberRoles, _getProjectMemberFeatures)
  }

  private createSerachFilter(formControlName: string): Observable<any> | undefined {
    let x: any = this.messageGroupForm
    return x ? x.get(formControlName)?.valueChanges.pipe(
      startWith(''),
      debounceTime(200),
      filter(q => typeof q === "string")) : new Observable<any>();

  }

  getProjectName() {
    let currentProject = this.commonService.getCurrentProjectDetails();
    this.projectName = currentProject.projectCode + ' - ' + currentProject.projectDescription;
  }

  async getSerialNoLength() {
    let slNoArray = await this.elementLinkService.getNumberingSlNoLength(this.projectId, this.groupId, Module.Transmittal).toPromise();
    this.serialNoLength = slNoArray.serialNoLength != 0 ? slNoArray.serialNoLength : 5;
  }

  createTransmittalCoverSheet() {
    this.transmittalData = {
      templateName: 'common',
      to: this.toMember.memberName + '<br>' + this.toMember.address,
      attention: this.toMember.memberName,
      From: this.fromMember.memberName,
      cc: this.ccMembers.map(x => x.memberName).join(';'),
      subject: this.getFormValue('txtMailSubject', this.messageContentForm),
      date: formatDate(this.datevalue, 'dd-MMM-yyyy', 'en-US'),
      edrcRef: this.messageNo,
      cusRef: this.getFormValue('txtCusRef', this.messageContentForm),
      projName: this.projectName,
      docDetails: this.getTransViewModel(),
      distributionDetails: this.getDistributionViewModel(),
      is_Show_Attachment_In_DTN: this.is_Show_Attachment_In_DTN,
      task_id_list: this.task_id_list,
      message_Note: this.selectedRemarks,
      fileDetails: this.attachmentsList && this.attachmentsList.length > 0 ? this.attachmentsList : []
    };
    this.ShowTransmittalTemplate = true;
  }

  getTransViewModel(): ITransmittalViewDocDetails[] {
    return this.documentUpdateList.map(x => {
      let type_Desc: string = '';
      let type_Short_Desc: string = '';

      if (!!x.type) {
        type_Desc = x.type.map((x: {
          dedDescription: any;
        }) => x.dedDescription).toString();
        type_Short_Desc = x.type.map((x: {
          dedShortDescription: any;
        }) => x.dedShortDescription).toString();
      }
      let category_Desc: string = '';
      let category_Short_Desc: string = '';
      if (!!x.category) {
        category_Desc = x.category.dedDescription;
        category_Short_Desc = x.category.dedShortDescription;
      }
      let transDocViewModel: ITransmittalViewDocDetails = {
        authorised_By: x.authorized_By,
        doc_Id: x.doc_Id,
        doc_No: x.document_No,
        doc_Title: x.title,
        revision_No: x.revision_No,
        remarks: x.remarks,
        quantity: x.quantity,
        type_Description: type_Desc,
        type_Short_Description: type_Short_Desc,
        category_Description: category_Desc,
        category_Short_Description: category_Short_Desc,
        scheduleType: x.scheduleType,
        task_Id: x.task_Id
      };
      return transDocViewModel;
    });
  }

  getDistributionViewModel(): ITransmittalDistributionViewModel[] {
    return this.distributionList.map(x => {
      let distributionView: ITransmittalDistributionViewModel = {
        member_Name: x.members.map((mem: {
          memberName: any;
        }) => mem.memberName).join('/'),
        receiver_Group: x.receiver_Group,
        quantity: x.quantity,
        remarks: x.remarks,
        category_Description: x.category.dedDescription,
        category_Short_Description: x.category.dedShortDescription,
        type_Description: x.type.map((x: {
          dedDescription: any;
        }) => x.dedDescription).toString(),
        type_Short_Description: x.type.map((x: {
          dedShortDescription: any;
        }) => x.dedShortDescription).toString(),
        category: x.category.dedId,
        copy_Type: x.type.dedId
      }
      return distributionView;
    })
  }

  createTransmittalGroupForm() {
    this.transmittalForm = this._formBuilder.group({
      txtMsgSerialNo: new FormControl({
        value: '',
        disabled: true
      }),
      txtSerialNo: new FormControl({
        value: '',
        disabled: true
      }, [Validators.pattern("^[0-9]*$")]),
      lblIsConfidential: new FormControl(false),
      category: new FormControl('', Validators.required),
      formCategory: new FormControl('', Validators.required),
      txtquantity: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      formType: new FormControl(''),
    });
    this.transmittalForm.get('txtMsgSerialNo')?.valueChanges.subscribe((x: any) => {
      this.generateMessageNo();
    });
    this.transmittalForm.get('txtSerialNo')?.valueChanges.subscribe((x: any) => {
      this.generateMessageNo();
    })
    this.messageGroupForm = this._formBuilder.group({
      ccMembersCtrl: new FormControl(),
      ccMembers: [
        [],
        [Validators.required, this.validateMemberSelection.bind(this)]
      ],
      txtNoOfDays: new FormControl(),
      fromMember: new FormControl('', Validators.required),
      formFromMember: new FormControl('', Validators.required),
      toMember: new FormControl('', Validators.required),
      formToMember: new FormControl('', Validators.required)
    });
    this.messageContentForm = this._formBuilder.group({
      txtMailSubject: new FormControl(),
      txtCusRef: new FormControl()
    });

  }

  private filterMembers(): void {

    this.ccFilteredMembers = this.getFilteredMembers(this.ccfilter$);
  }

  private getFilteredMembers(filter$: Observable<any>): Observable<ITransmittalMemberModel[]> {
    return filter$.pipe(
      switchMap((filter: any) => {
        //Note: Reset the page with every new seach text
        let currentPage = 1;
        return this._nextPage$.pipe(
          startWith(currentPage),
          exhaustMap(_ => this.getMembersFake(filter, currentPage)),
          tap(() => currentPage++),
          scan((allMembers, newMembers: any) => allMembers.concat(newMembers), []),
        );
      }));
  }

  // Fake backend api
  private getMembersFake(startsWith: string, page: number): Observable<ITransmittalMemberModel[]> {
    const take = 10;
    const skip = page > 0 ? (page - 1) * take : 0;
    const filtered = this.masterMembers
      .filter(option => option.memberName?.toLowerCase().includes(startsWith.toLowerCase()));
    return of(filtered.slice(skip, skip + take));
  }

  optionClicked(event: Event, member: ITransmittalMemberModel, type: string) {
    event.stopPropagation();
    switch (type) {
      case 'cc':
        this.toggleCcSelection(member);
        break;
    }
  }

  viewMessageList(category: number, data: any) {
    let inputModel: IDocumentMailInputModel = {
      DocId: data.doc_Id,
      DocumentNo: data.document_No,
      Category: category,
      ProjectId: this.projectId,
      GroupId: this.groupId,
      MemberId: this.memberId,
      TransType: "",
      revisionNo: null
    };
    this.dialog.open(ScheduleDocumentMailListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: inputModel
    });
  }

  toggleCcSelection(member: ITransmittalMemberModel) {
    const index: number = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.ccMembers.splice(index, 1);
      this.ccFormMembers?.value.splice(index, 1);
      this.ccFormMembers?.updateValueAndValidity();
    } else {
      this.ccMembers.push(member);
      this.ccFormMembers?.value.push(member);
      this.ccFormMembers?.updateValueAndValidity();
      this.resetCcMemberFilter();
    }
  }

  isMemberSelected(member: ITransmittalMemberModel, type: string): boolean {
    let result: boolean = false;
    switch (type) {
      case 'cc':
        result = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
    }
    return result;
  }

  resetCcMemberFilter() {
    this.messageGroupForm.get('ccMembersCtrl')?.setValue('');
    this.ccInput.nativeElement.value = '';
    this.ccInput.nativeElement.blur();
  }

  removeCc(member: ITransmittalMemberModel): void {
    const index = this.ccMembers.indexOf(member);
    if (index >= 0) {
      this.ccMembers.splice(index, 1);
      // Remove element from control value array
      this.ccFormMembers?.value.splice(index, 1);
      // where index = index of removed element
      this.ccFormMembers?.updateValueAndValidity();
      this.resetCcMemberFilter();
    }
  }

  // use getter method to access toMembers control value easily
  get toMember(): ITransmittalMemberModel {
    return this.messageGroupForm.get('toMember')?.value;
  }

  get ccFormMembers() {
    return this.messageGroupForm.get('ccMembers');
  }

  get fromMember(): ITransmittalMemberModel {
    return this.messageGroupForm.get('fromMember')?.value;
  }

  onScroll() {
    //Note: This is called multiple times after the scroll has reached the 80% threshold position.
    this._nextPage$.next();
  }

  onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
    switch (formGroupName) {
      case "message":
        this.messageGroupForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
        break;
    }

  }

  validateMemberSelection(abstractControl: AbstractControl): ValidationErrors | null | undefined | any {
    if (abstractControl.touched || abstractControl.dirty) {
      let selectedValue: any[] = abstractControl.value;
      if (!!selectedValue) {
        selectedValue = selectedValue.map(x => x.memberId);
      }
      if (selectedValue && !selectedValue.every(member => this.masterMemberIds.includes(member))) {
        return {
          IsError: true
        };
      } else {
        return null;
      }
    }
  }

  ontransmittalFormatChange(value: string) {
    this.transmittalFormat = value;
  }

  onNumFormatChange(value: string) {
    this.numFormat = value;
    this.isShowSerialNo = this.numFormat == 'Auto' || this.numFormat == 'Semi';
    if (this.numFormat == 'Auto') {
      this.transmittalForm.get('txtMsgSerialNo')?.disable();
      this.transmittalForm.get('txtSerialNo')?.disable();
      this.GetMessageSerialNo();
    } else if (this.numFormat == 'Semi') {
      this.transmittalForm.get('txtSerialNo')?.enable();
      this.transmittalForm.get('txtMsgSerialNo')?.disable();
      this.GetMessageSerialNo();
    } else if (this.numFormat == 'Manual') {
      this.transmittalForm.get('txtMsgSerialNo')?.setValue('');
      this.transmittalForm.get('txtSerialNo')?.setValue('');
      this.transmittalForm.get('txtMsgSerialNo')?.enable();
      this.transmittalForm.get('txtSerialNo')?.disable();
    }
  }

  public getMessageNumber(): string {
    let docNo: string = this.getFormValue("txtMsgSerialNo", this.transmittalForm);
    if (this.numFormat == 'Auto' || this.numFormat == 'Semi')
      return docNo + '-' + this.getFormValue("txtSerialNo", this.transmittalForm);
    else
      return docNo;
  }

  onResponseRequiredChange(value: any) {
    this.responseRequired = value;
  }

  attachmentClick(data: any) {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: {
        projectId: this.projectId,
        msgId: -1,
        docId: data.doc_Id,
        revisionNo: data.revision_No,
        libraryName: FileUploadLibrary.SignedDocuments,
        createdBy: this.memberId,
        documents: [{
          value: data.doc_Id,
          text: data.document_No,
          revisionNo: data.revision_No
        }],
        isEditable: false
      },
    });
    dialog.componentInstance.onUploadFinished.subscribe(res => {
      let fileName: string = res.fileName;
      let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.signedDocuments.push({
        docId: res.docId,
        fileName: fileName.substring(0, fileName.lastIndexOf(".")),
        fileExtension: fileExtn,
        fileSize: res.fileSize,
        revisionNo: res.revisionNo
      });
    });
    dialog.afterClosed().subscribe((res: any) => {
      let _getFiles = this._fileService.GetFiles({
        libraryNumber: FileUploadLibrary.SignedDocuments,
        value: JSON.stringify({
          projectId: this.projectId,
          docId: data.doc_Id,
          revisionNo: data.revision_No
        })
      }).subscribe((_data: any[]) => {
        data.isAttachemtUploded = _data.length > 0 ? true : false;
      });
      this.UnsubscribeArray.push(_getFiles)
    });
  }

  bulkAttachmentClick() {
    if (this.documentViewList.length > 0) {
      let documentList: Array<any> = new Array<any>();
      this.documentViewList.forEach((dataItem, rowIndex) => {
        documentList.push({
          value: dataItem.doc_Id,
          text: dataItem.document_No,
          revisionNo: dataItem.revision_No
        });
      });

      const dialog = this.dialog.open(FileUploadComponent, {
        panelClass: 'mat-dialog-secondary',
        width: '50%',
        data: {
          projectId: this.projectId,
          msgId: -1,
          docId: 0,
          revisionNo: "",
          libraryName: FileUploadLibrary.SignedDocuments,
          createdBy: this.memberId,
          documents: documentList,
          isEditable: true
        },
      });
      dialog.componentInstance.onUploadFinished.subscribe(res => {
        let fileName: string = res.fileName;
        let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
        this.signedDocuments.push({
          docId: res.docId,
          fileName: fileName.substring(0, fileName.lastIndexOf(".")),
          fileExtension: fileExtn,
          fileSize: res.fileSize,
          revisionNo: res.revisionNo
        });
      });
      dialog.afterClosed().subscribe((res: any) => {
        this.documentViewList.forEach((dataItem, rowIndex) => {
          let _getFiles = this._fileService.GetFiles({
            libraryNumber: FileUploadLibrary.SignedDocuments,
            value: JSON.stringify({
              projectId: this.projectId,
              docId: dataItem.doc_Id,
              revisionNo: dataItem.revision_No
            })
          }).subscribe((_data: any[]) => {
            dataItem.isAttachemtUploded = _data.length > 0 ? true : false;
          });
          this.UnsubscribeArray.push(_getFiles)
        });
      });
    }
  }

  viewAttachmentClick(data: ITransmittalDocViewModel) {
    if (this.MessageId > 0) {
      const dialog = this.dialog.open(FileListComponent, {
        panelClass: 'mat-dialog-secondary',
        width: '70%',
        data: {
          projectId: this.projectId,
          msgId: this.MessageId,
          docId: data.doc_Id,
          revisionNo: data.revision_No,
          libraryName: (data.scheduleType == 3 || this.is_Show_Attachment_In_DTN) ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments,
          createdBy: this.memberId,
          isDeleteEnable: false,
          documentNo: this.messageNo,
          task_ID: this.task_id_list
        },
      });

      dialog.afterClosed().subscribe((res: any) => {
        let _getFiles = this._fileService.GetFiles({
          libraryNumber: (data.scheduleType == 3 || this.is_Show_Attachment_In_DTN) ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments,
          value: JSON.stringify({
            projectId: this.projectId,
            docId: data.doc_Id,
            revisionNo: data.revision_No
          })
        }).subscribe((_data: any[]) => {
          data.isAttachemtUploded = _data.length > 0 ? true : false;
        });
        this.UnsubscribeArray.push(_getFiles)
      });
    } else {
      const dialog = this.dialog.open(FileListComponent, {
        panelClass: 'mat-dialog-secondary',
        width: '70%',
        data: {
          projectId: this.projectId,
          msgId: -1,
          docId: data.doc_Id,
          revisionNo: data.revision_No,
          libraryName: (data.scheduleType == 3 || this.is_Show_Attachment_In_DTN) ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments,
          createdBy: this.memberId,
          isDeleteEnable: data.scheduleType == 3 ? false : true,
          documentNo: this.messageNo,
          task_ID: data.task_Id ? data.task_Id : this.task_id_list
        },
      });
      dialog.afterClosed().subscribe((res: any) => {
        let _getFiles = this._fileService.GetFiles({
          libraryNumber: (data.scheduleType == 3 || this.is_Show_Attachment_In_DTN) ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments,
          value: JSON.stringify({
            projectId: this.projectId,
            docId: data.doc_Id,
            revisionNo: data.revision_No
          })
        }).subscribe((_data: any[]) => {
          data.isAttachemtUploded = _data.length > 0 ? true : false;
        });
        this.UnsubscribeArray.push(_getFiles)
      });
    }
  }

  public cancelHandler(rowIndex: any): void {
    this.closeEditor(rowIndex);
  }

  private closeEditor(rowIndex: number | undefined): void {
    this.docGrid.closeRow(rowIndex);
  }

  editDocRowDynamic(dataItem: any) {
    let rowIndex = this.documentViewList.findIndex(data => data.category == dataItem.category && data.type == dataItem.type);

    if (!!dataItem.category) {
      this.DocSelectedCategory = dataItem.category.dedId;
    } else {
      this.DocSelectedCategory = null;
    }
    if (!!dataItem.type) {
      this.DocSelectedType = dataItem.type.dedId;
    } else {
      this.DocSelectedType = null;
    }
    this.docGrid.editRow(rowIndex);
  }

  cancelRowData(data: any) {
    data.sender.closeRow(data.rowIndex);
  }

  getDynamicForm() {
    let _getProjectElements = this._projService.getProjectElements({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.Transmittal,
      IsQueryForStaticElement: false
    }).subscribe(
      (res: IProjectElementsOutput[]) => {

        this.projectElements = res;
        this.elementsConfig = res.map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.Transmittal,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
            value: new BehaviorSubject(null)
          }
          if (x.isMandatory) {
            field.validations = [{
              name: "required",
              validator: Validators.required,
              message: field.name + " is Required"
            }]
          }
          if (x.isNumbering) {
            this.numElements.set(x.elementDescription, '');
          }
          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();

        let resForm: FormGroup = this.dynamicForm.value;
        //Numbering elements array
        let numberingElements: string[] = Array.from(this.numElements.keys());
        numberingElements.forEach(element => {
          resForm.get(element)?.valueChanges.subscribe((x: any) => {
            if (!!x) {
              if (this.numElements.has(element)) {
                if (!!x)
                  this.numElements.set(element, x.dedShortDescription);
                else
                  this.numElements.set(element, '');
              }
              if ((this.numFormat == 'Auto' || this.numFormat == 'Semi'))
                this.GetMessageSerialNo();
            }
          });
        });
        this.onCascadingAutocomplete_Change();
      });
    this.UnsubscribeArray.push(_getProjectElements)
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach((data: any) => {
      if (!!data.child_de_id) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe((x: any) => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;

          if (_field.length > 0 && !!parentControlSelectedValue) {
            let _getProjectElementCascadingDetails = this._projService.getProjectElementCascadingDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.Transmittal,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription,
              dependentDEId: _field[0].dependent_de_id,
              dependentDEDId: parentControlSelectedValue.dedId
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                _field[0].values = res;
              } else {
                _field[0].values = [];
              }
            }, (err: any) => { });
            this.UnsubscribeArray.push(_getProjectElementCascadingDetails)
          } else {
            _field[0].values = [];
          }
        })
      }
    })
  }

  /**
   * Get elementDetailsForm Controls value
   * @param controlName ControlName
   */
  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }

  /**
   *Get Message Serial No
   */
  GetMessageSerialNo() {
    //Coin the Document number based on the element values selection changes
    let elementValues: string[] = Array.from(this.numElements.values());
    let selectedElementValues: string[] = elementValues.filter(val => val != '');
    this.msgNo = elementValues.filter(val => val != '').join('-');
    this.transmittalForm.get('txtMsgSerialNo')?.setValue(this.msgNo);
    //Ensure all the mandatory numering elements selected
    if (elementValues.length > 0 && elementValues.length == selectedElementValues.length) {
      let resForm: FormGroup = this.dynamicForm.value;
      this.elementInp = this.projectElements.filter(x => x.isNumbering).map(x => {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        if (!!selectedValue) {
          let result: ITransmittalElementSLNoInputModel = {
            deId: x.elementId,
            dedId: selectedValue.dedId,
            deDescription: x.elementDescription,
            dedDescription: selectedValue.dedDescription,
            dedShortDescription: selectedValue.dedShortDescription,
            sortBy: +selectedValue.sortBy


          }
          return result;
        }
      });
      let inputModel: ITransmittalSerialNoInputModel = {
        projectId: this.commonService.getProjectId(),
        groupId: this.groupId,
        moduleId: Module.Transmittal,
        elementDetails: this.elementInp
      };
      let _getTransmittalSerialNo = this._transmittalMsgService.getTransmittalSerialNo(inputModel).subscribe((result: StandardOutputModel) => {
        //Set manipulated value from the parent component(W.r.t other documents elements selection while bulk upload)
        this.transmittalForm.get('txtSerialNo')?.setValue(String(result.result).padStart(this.serialNoLength, '0'));
      });
      this.UnsubscribeArray.push(_getTransmittalSerialNo);
    }
  }

  /**
   * Get Element Details
   */
  public getElementDetails(elementName: string) {
    let _getProjectElementDetails = this._projService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.Transmittal,
      deDescription: elementName
    })
      .subscribe((res: any[]) => {
        switch (elementName) {
          case "Message Category":
            this.categoryList = res;
            if (this.categoryList.length == 1)
              this.transmittalForm.get("formCategory")?.setValue(this.categoryList[0].dedDescription);
            break;
          case "Copy Type":
            this.copyTypeList = res;
            break;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(_getProjectElementDetails);
  }

  setMessageValues(event: {
    text: string; additionalValues: {
      additionalValues: any;
    };
  }, formControlName: string) {
    this.mailType = event.text;
    this.transmittalForm.get(formControlName)?.setValue(event.additionalValues.additionalValues);
  }

  setTransmittalTypeValues(event: { emittingList: [additionalValues: any, value: number | null | undefined]; }, formControlName: string) {

    this.transmittalForm.get(formControlName).setValue(event.emittingList.map(x => x.additionalValues));
    this.selectedTransmittalType = event.emittingList.map(x => x.value);

    this.documentViewList.forEach((dataItem, rowIndex) => {
      let _type = this.transmittalForm.get("formType")?.value;

      if (!!_type) {
        let _getSelectedType: any[] = [];
        _getSelectedType = [];
        _getSelectedType = _type;

        dataItem.type = _getSelectedType;
        dataItem.selectedType = _getSelectedType.map(x => x.dedId)
      }

    });
  }

  saveTransmittal(is_Send_Mail: boolean) {
    if (this.messageGroupForm.valid && this.transmittalForm.valid && this.messageContentForm.valid && this.dynamicForm.value.valid) {
      let findEmptyfields: any;
      findEmptyfields = this.distributionList.filter((data, index) => {
        if (!data.type || !data.category || !data.quantity) {
          return data;
        }
      });
      if (findEmptyfields.length > 0) {
        this.editRowDynamic(findEmptyfields[0]);
        return;
      }
      if (this.distributionList.length == 0) {
        this.notificationService.showToast("Distribution List Cannot be Empty", "Warning");
        return;
      }
      if (this.documentList.length == 0) {
        this.notificationService.showToast("No Documents Attached", "Warning");
        return;
      }
      if (is_Send_Mail == false) {
        if (this.documentViewList && this.documentViewList.some(x => !x.isAttachemtUploded)) {
          this.notificationService.showToast("Every document should have at least one attachment", "Warning");
          return;
        }
      }

      this.previewTransmittal();
      let disciplineId = 0;
      let discipline = '';
      let selectedValue: any = this.dynamicForm.value.get("Discipline")?.value;
      if (selectedValue != null && selectedValue != undefined) {
        disciplineId = selectedValue.dedId;
        discipline = selectedValue.dedDescription;
      }
      let semiNo: string = '0';
      let msgNo: string = this.getFormValue("txtMsgSerialNo", this.transmittalForm);
      if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
        semiNo = this.getFormValue("txtSerialNo", this.transmittalForm);
        semiNo = semiNo.replace(/\D|^0+/g, "");
        msgNo = msgNo + '-' + this.getFormValue("txtSerialNo", this.transmittalForm);
      }
      let transmittalMsgInputDetails: ITransmittalMsgInputModel = {
        inputType: this.inputType,
        project_Id: this.projectId,
        message_Id: this.MessageId,
        message_Number: is_Send_Mail ? msgNo : null,
        message_Serial_Number: is_Send_Mail ? +semiNo : null,
        discipline: disciplineId,
        cust_Ref_No: this.getFormValue('txtCusRef', this.messageContentForm),
        parent_Message_Id: 0,
        message_Type: this.getFormValue('category', this.transmittalForm).dedId,
        has_Attachments: this.documentList.length > 0 || this.messageList.length > 0,
        is_Confidential: this.getFormValue('lblIsConfidential', this.transmittalForm) == null ? false : this.getFormValue('lblIsConfidential', this.transmittalForm),
        message_Category: 3,
        message_Subject: this.getFormValue('txtMailSubject', this.messageContentForm),
        message_Body: this.transmittalViewComponent.getHtmlContent(),
        response_Type: this.getFormValue('txtNoOfDays', this.messageGroupForm),
        respond_On: this.RespondOn,
        issue_Reason: 10,
        sent_On: is_Send_Mail ? this.datevalue : null,
        is_Mail_Sent: is_Send_Mail,
        is_Active: true,
        userId: this.memberId,
        message_Note: !!this.selectedRemarks ? this.selectedRemarks : null
      };
      let _insertUpdateTransmittalDetails = this._transmittalMsgService.InsertUpdateTransmittalDetails(transmittalMsgInputDetails).subscribe((x: StandardOutputModel | any) => {
        if (x.successCode == 200) {
          let messageId: number = +x.result;
          let transmittalReceiverDetails = this.saveTransmittalReceiverDetails(messageId);
          let transmittalDistributionDetails = this.saveTransmittalDistributionDetails(messageId);
          let transmittalDocMsgDetails = this.saveTransmittalMsgDocDetails(messageId);
          let transmittalDocDetails = this.saveTransmittalDocDetails(messageId);
          let transmittalDocCopyDetails = this.saveTransmittalDocCopyDetails(messageId);
          let transmittalDocEleDetails = this.saveTransmittalDocEleDetails(messageId)
          let _transmittaldDetails = forkJoin([transmittalReceiverDetails,
            transmittalDistributionDetails,
            transmittalDocMsgDetails,
            transmittalDocDetails,
            transmittalDocCopyDetails,
            transmittalDocEleDetails
          ]).subscribe((res: any[]) => {
            if (this.signedDocuments.length > 0) {
              let signedDocs: ITransmittalSignedDocumentsModel = {
                projectId: this.projectId,
                msgId: messageId,
                createdBy: this.memberId,
                signedDocuments: this.signedDocuments
              }
              let _updateSignedDocumentsMessageId = this._transmittalMsgService.UpdateSignedDocumentsMessageId(signedDocs).subscribe(async (res: StandardOutputModel | any) => {
                if (res.successCode != 200) {
                  this.notificationService.showPopup(res.successMessage, "Warning");
                }
              });
              this.UnsubscribeArray.push(_updateSignedDocumentsMessageId);
            }
            if (this.attachmentsList.length > 0) {
              let attachedDoc: IMsgAttachmentsModel = { projectId: this.projectId, msgId: messageId, createdBy: this.memberId, messageDocuments: this.attachmentsList }
              let _updateCommunicationDocumentMessageId = this.communicationService.updateCommunicationDocsMsgId(attachedDoc).subscribe((res: any) => {
                if (res.successCode != 200) {
                  this.notificationService.showPopup(res.successMessage, "Warning");
                }
              });
              this.UnsubscribeArray.push(_updateCommunicationDocumentMessageId);
            }

            if (is_Send_Mail == true) {
              let sTo: string = this.toMember.eMailId;
              let sCC: string = this.ccMembers.map((x: any) => x.eMailId).join(',');
              let sFrom: string = this.fromMember.eMailId;
              let mailDetails: ITransmittalMailDetails = {
                from_List: sFrom,
                to_List: sTo,
                cc_List: sCC,
                project_Code: this.commonService.getProjectCode(),
                discipline: discipline,
                mail_Body: this.transmittalViewComponent.getHtmlContent(),
                mail_Subject: this.getFormValue('txtMailSubject', this.messageContentForm),
                message_Id: messageId
              }
              let _sendTransmittalMail = this._transmittalMsgService.SendTransmittalMail(mailDetails).subscribe((res: StandardOutputModel | any) => {
                if (res.successCode == 200 || res.successCode == 205) {
                  if (this.isWorkflow != true) {
                    this.notificationService.showPopup("Transmittal Sent successfully", "Success");
                  }
                  this.reSet();
                  this.getTransmittalDetails();
                  this.closeDialog(x.result);
                } else {
                  this.notificationService.showPopup(res.successMessage, "Warning");
                }
              });
              this.UnsubscribeArray.push(_sendTransmittalMail);
            } else {
              if (this.isWorkflow != true) {
                this.notificationService.showPopup("Transmittal Saved successfully", "Success");
              }
              this.reSet();
              this.getTransmittalDetails();
              this.closeDialog(x.result);
            }
          });
          this.UnsubscribeArray.push(_transmittaldDetails);
        } else {
          this.notificationService.showPopup(x.successMessage, "Warning");
        }
      });
      this.UnsubscribeArray.push(_insertUpdateTransmittalDetails);
    } else {
      this.notificationService.showPopup("Mandatory fields are required", "Warning");
      this.formMarkAsTouched(this.dynamicForm.form);
      this.formMarkAsTouched(this.messageGroupForm);
      this.formMarkAsTouched(this.transmittalForm);
      this.formMarkAsTouched(this.dynamicForm.form);
    }
  }

  private generateMessageNo() {
    let serialNo: any = this.getFormValue('txtSerialNo', this.transmittalForm);
    this.messageNo = this.getFormValue('txtMsgSerialNo', this.transmittalForm);
    if (!!serialNo) {
      this.messageNo = this.messageNo + "-" + this.getFormValue('txtSerialNo', this.transmittalForm);
    }
  }

  private saveTransmittalReceiverDetails(messageId: number) {
    let fromMembers: ITransmittalMemberModel[] = [];
    fromMembers.push(this.fromMember);
    let toMembers: ITransmittalMemberModel[] = [];
    toMembers.push(this.toMember);
    let transmittalReceiverInput: ITransmittalMsgReceiverInput = {
      message_Id: messageId,
      transmittalFromDetails: fromMembers.map(x => {
        let fromMember: IReceiverInput = {
          member_Id: x.memberId,
          receiver_Type: 1,
          receiver_Group: 0,
          sort_By: 1
        };
        return fromMember;
      }),
      transmittalToDetails: toMembers.map(x => {
        let toMember: IReceiverInput = {
          member_Id: x.memberId,
          receiver_Type: 2,
          receiver_Group: 0,
          sort_By: 1
        };
        return toMember;

      }),
      transmittalCcDetails: this.ccMembers.map(x => {
        let ccMember: IReceiverInput = {
          member_Id: x.memberId,
          receiver_Type: 3,
          receiver_Group: x.groupBy,
          sort_By: 1
        };
        return ccMember;

      }),
      is_Active: true,
      userId: this.memberId
    }
    return this._transmittalMsgService.InsertUpdateTransmittalReceiverDetails(transmittalReceiverInput);
  }

  private saveTransmittalDistributionDetails(messageId: number) {
    let transmittalDistributionInput: ITransmittalGroupMemberInput = {
      message_Id: messageId,
      distributionMemberDetails: this.distributionList.map(x => {
        let distDetails: IDistributionMemberDetails = {
          group_Id: x.receiver_Group,
          group_Member: x.members.map((mem: {
            memberName: any;
          }) => mem.memberName).join('/'),
          quantity: x.quantity,
          category: x.category == null ? "" : x.category.dedShortDescription,
          copy_Type: x.type == null ? "" : x.type.map((x: {
            dedShortDescription: any;
          }) => x.dedShortDescription).toString(),
          address: null,
          remarks: x.remarks
        };
        return distDetails;
      }),
      is_Active: true,
      userId: this.memberId

    }
    return this._transmittalMsgService.InsertUpdateTransmittalGroupMemberDetails(transmittalDistributionInput);
  }

  private saveTransmittalMsgDocDetails(messageId: number) {
    let transmittalDocumentMessageInput: ITransmittalMsgDocumentInput = {
      message_Id: messageId,
      transmittalDocumentMessageDetails: this.documentUpdateList.map(x => {
        let distDetails: ITransmittalDocumentMsgDetails = {
          doc_Id: x.doc_Id,
          revision_No: x.revision_No,
          response_Remarks: x.remarks,
          response: this.getFormValue('txtNoOfDays', this.messageGroupForm),
        };
        return distDetails;

      }),
      is_Active: true,
      userId: this.memberId

    }
    return this._transmittalMsgService.InsertUpdateTransmittalMsgDocDetails(transmittalDocumentMessageInput);
  }

  private saveTransmittalDocDetails(messageId: number) {
    let transmittalDocumentInput: ITransmittalDocumentInput = {
      message_Id: messageId,
      transmittalDocumentDetails: this.documentUpdateList.map(x => {
        let distDetails: ITransmittalDocumentDetails = {
          doc_Id: x.doc_Id,
          revision_No: x.revision_No,
          quantity: x.quantity,
          doc_Type: x.type.map((x: {
            dedShortDescription: any;
          }) => x.dedShortDescription).toString(),
          category: x.category.dedId,
          remarks: x.remarks
        };
        return distDetails;

      }),
      is_Active: true,
      userId: this.memberId
    }
    return this._transmittalMsgService.InsertUpdateTransmittalDocDetails(transmittalDocumentInput);
  }

  private saveTransmittalDocCopyDetails(messageId: number) {
    let transmittalDocumentCopyInput: any = {
      message_Id: messageId,
      transmittalDocumentCopyDetails: this.documentUpdateList.map(x => {
        let distDetails: ITransmittalDocumentCopyDetails = {
          doc_Id: x.doc_Id,
          revision_No: x.revision_No,
          no_of_Copies: x.quantity,
          copy_Type: x.type.dedId,
        };
        return distDetails;

      }),
      is_Active: true,
      userId: this.memberId
    }
    return this._transmittalMsgService.InsertUpdateTransmittalDocCopyDetails(transmittalDocumentCopyInput);
  }

  private saveTransmittalDocEleDetails(messageId: number) {
    let transmittalDocEleDetails: ITransmittalDocumentElementDetails[] = [];
    let resForm: FormGroup = this.dynamicForm.value;
    transmittalDocEleDetails = this.projectElements.map(x => {
      let selectedValue: any = resForm.get(x.elementDescription)?.value;
      let result: ITransmittalDocumentElementDetails = {
        deId: x.elementId,
        dedId: selectedValue.dedId,
        userId: this.memberId,
        isActive: true,
        messageId: messageId
      }
      return result;
    });
    let transmittalDocumentElement: ITransmittalDocumentElementInput = {
      elementDetailsMapping: transmittalDocEleDetails
    }
    return this._transmittalMsgService.InsertUpdateTransmittalDocElementDetails(transmittalDocumentElement);
  }

  async getMembers() {
    this.membersList = await this.memberService.GetMembersList({
      group_Id: this.groupId,
      member_Id: null
    }).toPromise();
  }

  public getSignatureList() {
    let _getSignatureList = this.communicationService.GetSignatureList({
      MemberId: this.memberId
    })
      .subscribe((res: ISignatureOutputModel[]) => {
        this.signatureList = res;
      }, (err: any) => { });
    this.UnsubscribeArray.push(_getSignatureList);
  }

  showDocumentCart() {
    let obj: any = {}
    if (this.documentViewList.length > 0) {
      obj["data"] = this.documentViewList;
    }
    const dialogRef = this.dialog.open(DocumentViewGridComponent, {
      panelClass: 'mat-dialog-primary',
      data: obj
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.WorkflowDocument = res;
      if (res.length > 0) {
        this.reciviedDoc = res.filter((data: {
          isSelected: boolean;
        }) => data.isSelected == true);
        Array.prototype.push.apply(this.documentList, this.reciviedDoc);
      } else {
        if (this.documentList.length < 0) {
          this.documentList = [];
        }
      }
      let currentDocList: ITransmittalDocViewModel[] = this.documentViewList;
      this.documentViewList = this.documentList.map(x => {
        let _category: any = this.transmittalForm.get("category")?.value;
        let _type: any = this.transmittalForm.get("formType")?.value;
        let _remarks: any = "";
        let _quantity: any = this.transmittalForm.get("txtquantity")?.value;
        let transDocViewModel: ITransmittalDocViewModel = currentDocList.filter(tdoc => tdoc.doc_Id == x.docId)[0];
        if (!!transDocViewModel) {
          _category = transDocViewModel.category;
          _type = transDocViewModel.type;
          _remarks = transDocViewModel.remarks;
          _quantity = transDocViewModel.quantity;
        }

        this._getSelected_Type = [];
        this._getSelected_Type.push(_type);

        let docViewModel: ITransmittalDocViewModel = {
          doc_Id: x.docId,
          revision_No: x.revision,
          title: x.title,
          document_No: x.documentNo,
          authorized_By: x.authorisedByName,
          category: _category,
          type: this._getSelected_Type,
          remarks: _remarks,
          quantity: _quantity,
          isAttachemtUploded: false,
          selectedCategory: _category.dedId,
          selectedType: this._getSelected_Type.map(x => x.dedId)
        };
        return this.validateAttachment(docViewModel);
      });
      this.documentUpdateList = this.documentViewList;
    });
  }

  validateAttachment(input: ITransmittalDocViewModel, task_Id?: string): ITransmittalDocViewModel {
    let _getFiles = this._fileService.GetFiles({
      libraryNumber: (input.scheduleType == 3 || this.is_Show_Attachment_In_DTN) ? FileUploadLibrary.WorkflowDocument : FileUploadLibrary.SignedDocuments,
      value: JSON.stringify({
        projectId: this.projectId,
        docId: input.doc_Id,
        revisionNo: input.revision_No,
        task_ID: task_Id ? task_Id : this.task_id_list
      })
    }).subscribe((_data: any[]) => {
      input.isAttachemtUploded = _data.length > 0 ? true : false;
      return input;
    });
    this.UnsubscribeArray.push(_getFiles);
    return input;
  }

  removeDocument(data: any) {
    if (this.documentList.length > 0) {
      this.documentList.forEach((value, index) => {
        if (value.docId == data.dataItem.doc_Id) {
          this.documentList.splice(index, 1);
        }
      });
    }
    if (this.documentViewList.length > 0) {
      this.documentViewList.forEach((value, index) => {
        if (value.doc_Id == data.dataItem.doc_Id) {
          this.documentViewList.splice(index, 1);
        }
      });
    }
    if (this.signedDocuments.length > 0) {
      this.signedDocuments.forEach((value, index) => {
        if (value.docId == data.dataItem.doc_Id) {
          this.documentList.splice(index, 1);
        }
      })
    }
    this.documentUpdateList = this.documentViewList;
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', {
      month: 'short'
    })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }

  getValue(selectedText: {
    value: string | null;
  }) {
    this.isRevisedDateInvalid = selectedText.value == null;
    this.RespondOn = selectedText.value;
  }

  addDays() {
    let value = this.getFormValue('txtNoOfDays', this.messageGroupForm);
    if (!isNaN(value)) {
      var futureDate = new Date();
      futureDate.setDate(futureDate.getDate() + value);
      this.RespondOn = formatDate(futureDate, 'dd-MM-yyyy', 'en-US');;
      this.datevalue = futureDate;
      return futureDate;
    } else {
      this.notificationService.showToast("Enter Valid Number", "Warning");

    }
  }

  closeDialog(message_Number?: string) {
    if (this.attachmentsList && this.attachmentsList.length > 0 && !message_Number) {
      this.attachmentsList.forEach(x => {
        this._fileService.DeleteFile({ libraryNumber: 4, fileId: x.fileId, fileName: x.fileName + '.' + x.fileExtension }).subscribe(data => { });
      })
    }
    this.dialogRef.close(message_Number);
  }

  getGroupByValue(member: ITransmittalMemberModel): number | null | undefined {
    return member.groupBy;
  }

  onGroupByChange(value: number, member: ITransmittalMemberModel) {
    if (typeof Number(value) === "number")
      member.groupBy = value;
    else
      member.groupBy = null;
  }

  getElementDesc(element: any): string {
    if (!!element)
      return element.dedShortDescription + ' - ' + element.dedDescription;
    return '';
  }

  getTypeElementDesc(element: any[]): string {
    if (!!element && element.length > 0)
      return element.map(x => x.dedShortDescription).toString();
    return '';
  }

  public getTransmittalDetails() {
    let _getTransmittalDetails = this._transmittalService.GetTransmittalDetails({
      project_Id: this.projectId,
      group_Id: this.groupId
    })
      .subscribe((res: ITransmittalTemplateModel[]) => {
        this.templateDetails = res;
      }, (err: any) => { });
    this.UnsubscribeArray.push(_getTransmittalDetails);
  }

  numberOnly(event: {
    which: any; keyCode: any;
  }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else {
      return true;
    }
  }

  changeTransmittalTemplateList(event: {
    value: string | number | null;
  }) {
    if (event.value != "-2") {
      this.reSet();
      this.template_Id = event.value;
      let transmittalDetails: Observable<any> = this._transmittalService.GetTransmittalDetails({
        project_Id: this.projectId,
        group_Id: this.groupId,
        template_Id: event.value
      });
      let receiverDetails: Observable<any> = this._transmittalService.GetTransmittalReceiverDetails({
        template_Id: event.value
      });
      let distributionDetails: Observable<any> = this._transmittalService.GetTransmittalDistributionDetails({
        template_Id: event.value
      });
      let _transmittalDetails = forkJoin(transmittalDetails, receiverDetails, distributionDetails).subscribe((res: any[]) => {
        this.setTransmittalDetails(res[0]);
        this.setReceiverDetails(res[1]);
        let sortedCcMembers: ITransmittalMemberModel[] = sortBy(this.ccMembers, x => x.groupBy);
        let groupByResult: ITransmittalMemberModel[][] = map(groupBy(sortedCcMembers, x => x.groupBy));
        this.distributionList = res[2].map((x: {
          copy_Type: {
            toString: () => string;
          }; receiver_Group: number | null | undefined; category: any; remarks: any; quantity: any;
        }) => {
          this.getSelected_Type = [];
          let selected_type: any[];
          selected_type = x.copy_Type.toString().replace(/-/g, "").split(',');
          for (let i = 0; i < selected_type.length; i++) {
            for (let j = 0; j < this.copyTypeList.length; j++) {
              if (selected_type[i] == this.copyTypeList[j].dedShortDescription) {
                this.getSelected_Type.push(this.copyTypeList[j]);
              }
            }
          };
          let distributerViewModel: ITransmittalGroupViewModel = {
            receiver_Group: x.receiver_Group,
            members: groupByResult.filter(y => y.filter(z => z.groupBy == x.receiver_Group)[0])[0],
            category: this.categoryList.filter(y => y.dedId == x.category)[0],
            type: this.getSelected_Type,
            remarks: x.remarks,
            quantity: x.quantity
          };
          return distributerViewModel;
        });

        this.documentViewList.forEach((dataItem, rowIndex) => {
          let _category = this.categoryList.filter(y => y.dedId == res[0][0].category)[0];
          let _quantity = res[0][0].quantity;
          let _type = this.transmittalForm.get("formType")?.value;

          if (!!_category) {
            dataItem.category = _category;
            dataItem.selectedCategory = _category.dedId
          }

          if (!!_quantity) {
            dataItem.quantity = _quantity;
          }

          if (!!_type) {
            let _getSelectedType: any[] = [];
            _getSelectedType = [];
            _getSelectedType.push(_type);

            dataItem.type = _getSelectedType;
            dataItem.selectedType = _getSelectedType.map(x => x.dedId)
          }

        });
      });
      this.UnsubscribeArray.push(_transmittalDetails);
    } else {
      this.reSet();
    }
  }

  setTransmittalDetails(res: ITransmittalTemplateModel[]) {
    this.messageContentForm.get("txtMailSubject")?.setValue(res[0].template_Subject);
    this.transmittalForm.get("txtquantity")?.setValue(res[0].quantity);
    this.selectedCategory = res[0].category;
    this.selectedRemarks = res[0].template_Remarks;
    this.transmittalForm.get("formCategory")?.setValue(this.selectedCategory);
  }

  setReceiverDetails(transmittalReceiverInput: ITransmittalReceiverDetails[]) {
    let fromMembers: ITransmittalMemberModel[] = this.getTransmittalMembers(transmittalReceiverInput[0].receiverFromDetails);
    if (!!fromMembers && !!fromMembers[0]) {
      this.selectedFrom = fromMembers[0].memberId;
      this.messageGroupForm.get("formFromMember")?.setValue(this.selectedFrom);
    }
    let toMembers: ITransmittalMemberModel[] = this.getTransmittalMembers(transmittalReceiverInput[0].receiverToDetails);
    if (!!toMembers && !!toMembers[0]) {
      this.selectedTo = toMembers[0].memberId;
      this.messageGroupForm.get("formToMember")?.setValue(this.selectedTo);
    }
    this.ccMembers = this.getTransmittalMembers(transmittalReceiverInput[0].receiverCcDetails);
    if (this.ccMembers != null) {
      this.ccFormMembers.setValue([...this.ccMembers]);
    }

    this.ccFormMembers.updateValueAndValidity();

    this.resetCcMemberFilter();
  }

  showGroupView() {
    this.distGrid.closeRow(this.DistrowIndex);
    if (this.ccMembers.filter(x => !x.groupBy).length > 0) {
      this.notificationService.showPopup("Please enter group by value for all CC members", "Warning");
      return;
    }
    let sortedCcMembers: ITransmittalMemberModel[] = sortBy(this.ccMembers, x => x.groupBy);
    let groupByResult: ITransmittalMemberModel[][] = map(groupBy(sortedCcMembers, x => x.groupBy));
    let existingDistributionList: ITransmittalGroupViewModel[] = this.distributionList;
    this.distributionList = groupByResult.map(x => {
      let groupBy: any = x[0].groupBy;
      let category: any = this.transmittalForm.get("category")?.value;;
      let type: any = null;
      let quantity: any = this.transmittalForm.get('txtquantity')?.value;
      let remarks: any = "";
      if (!!existingDistributionList && existingDistributionList.length > 0) {
        let groupView: ITransmittalGroupViewModel = existingDistributionList.filter(dl => dl.receiver_Group == x[0].groupBy)[0];
        if (!!groupView) {
          category = groupView.category;
          type = groupView.type;
          quantity = groupView.quantity;
          remarks = groupView.remarks;
        }
      }
      let distributerViewModel: ITransmittalGroupViewModel = {
        receiver_Group: groupBy,
        members: x,
        category: category,
        type: type,
        remarks: remarks,
        quantity: quantity
      };
      return distributerViewModel;
    })
  }

  getMemberNames(dataItem: ITransmittalMemberModel[]): string {
    return dataItem.map(x => x.memberName).join(' / ');
  }

  private saveCurrentDistribution(): void {
    if (this.formGroupDist) {
      this.currentEditGroupViewModel.type = this.formGroupDist.get('type')?.value;
      this.currentEditGroupViewModel.category = this.formGroupDist.get('category')?.value;
      this.currentEditGroupViewModel.quantity = this.formGroupDist.get('quantity')?.value;
      this.currentEditGroupViewModel.remarks = this.formGroupDist.get('remarks')?.value;
      if (this.distributionList.filter(x => x.receiver_Group == this.currentEditGroupViewModel.receiver_Group).length > 0) {
        let index = this.distributionList.findIndex(x => x.receiver_Group == this.currentEditGroupViewModel.receiver_Group);
        this.distributionList.splice(index, 1);
      }
      this.distributionList.push(this.currentEditGroupViewModel);
      this.closeEditorDistList();
    }
  }

  /**
   * Close the row editor
   */
  public cancelHandlerDistList(): void {
    this.closeEditorDistList();
  }

  private closeEditorDistList(): void {
    this.distGrid.closeRow(this.editedRowIndex);
    this.editedRowIndex = undefined;
    this.currentEditGroupViewModel = undefined;
    this.formGroupDist = undefined;
  }

  editRowDynamic(dataItem: any) {
    this.formGroupDist = createFromGroupDist(dataItem);
    this.distributionList = this.distributionList.sort((a, b) => a.receiver_Group - b.receiver_Group);
    let rowIndex!: number;
    for (let i = 0; i < this.distributionList.length; i++) {
      if (this.distributionList[i].receiver_Group == dataItem.receiver_Group) {
        rowIndex = i;
        break;
      }
    }
    if (this.editedRowIndexDist >= 0) {
      this.grid.closeRow(this.editedRowIndex);
    }
    if (!!dataItem.category) {
      this.selected_Category = dataItem.category.dedId;
      this.formGroupDist.get('category')?.setValue(this.selected_Category);
    } else {
      this.selected_Category = null;
      this.formGroupDist.get('category')?.setValue(null);
    }
    if (!!dataItem.type) {
      this.selected_Type = dataItem.type.map((x: {
        dedId: any;
      }) => x.dedId);
      this.formGroupDist.get('type')?.setValue(this.selected_Type);
    } else {
      this.selected_Type = [];
      this.formGroupDist.get('type')?.setValue(null);
    }
    this.formGroupDist.get('quantity')?.setValue(dataItem.quantity);
    this.editedRowIndexDist = rowIndex;
    this.editedRowIndex = rowIndex;
    this.editedRowIndexDist = rowIndex;
    this.currentEditGroupViewModel = dataItem;
    this.distGrid.editRow(rowIndex);
  }

  editRowDataDist(data: any) {
    this.selected_Type = [];
    this.DistrowIndex = data.rowIndex;
    this.formGroupDist = createFromGroupDist(data.dataItem);
    //closing previous row, if anything opened
    if (this.editedRowIndexDist >= 0) {
      data.sender.closeRow(this.editedRowIndexDist);
    }
    this.editedRowIndexDist = data.rowIndex;
    if (!!data.dataItem.type && data.dataItem.type.length > 0) {
      this.selected_Type = data.dataItem.type.map((x: {
        dedId: any;
      }) => x.dedId);
      this.formGroupDist.get('type')?.setValue(this.selected_Type);
    } else {
      this.selected_Type = [];
      this.formGroupDist.get('type')?.setValue([]);
    }
    if (!!data.dataItem.category) {
      this.selected_Category = data.dataItem.category.dedId;
      this.formGroupDist.get('category')?.setValue(this.selected_Category);
    } else {
      this.selected_Category = null;
      this.formGroupDist.get('category')?.setValue(null);
    }
    this.formGroupDist.get('quantity')?.setValue(data.dataItem.quantity);
    this.editedRowIndexDist = data.rowIndex;
    this.currentEditGroupViewModel = data.dataItem;
    data.sender.editRow(data.rowIndex);
  }

  public cellClickHandler(data: any): void {
    return;
  }

  bulkSave(grid: any) {
    if (this.documentViewList.length > 0) {
      let haserror: boolean = false;

      this.documentViewList.forEach((dataItem, rowIndex) => {
        if (!haserror) {
          let index = this.documentViewList.findIndex(x => x.doc_Id == dataItem.doc_Id);
          if (dataItem.quantity == undefined || dataItem.quantity == null || dataItem.quantity.toString() == "" || dataItem.quantity <= 0) {
            this.notificationService.showToast("Attached document grid serial number " + (index + 1) + " - No of Copies is required", "Warning");
            haserror = true;
            this.isShowbulkSave = true;
            return;
          } else if (dataItem.category == undefined || dataItem.category == null || dataItem.category.toString() == "") {
            this.notificationService.showToast("Attached document grid serial number " + (index + 1) + " - Category is required", "Warning");
            haserror = true;
            this.isShowbulkSave = true;
            return;
          } else if (dataItem.type == undefined || dataItem.type == null || dataItem.type.toString() == "") {
            this.notificationService.showToast("Attached document grid serial number " + (index + 1) + " - Type is required", "Warning");
            haserror = true;
            this.isShowbulkSave = true;
            return;
          } else {
            grid.closeRow(rowIndex);
            this.isShowbulkSave = false;
          }
        }
      });
    }
  }

  bulkCancel(grid: any) {
    if (this.documentViewList.length > 0) {
      this.isShowbulkSave = false;
      this.documentViewList.forEach((dataItem, rowIndex) => {
        grid.closeRow(rowIndex);
      });
    }
  }

  bulkDelete(grid: any) {
    this.isShowbulkSave = false;
    this.documentViewList = [];
  }

  bulkEdit(grid: any) {
    if (this.documentViewList.length > 0) {
      this.isShowbulkSave = true;
      this.documentViewList.forEach((dataItem, rowIndex) => {
        dataItem.selectedType = [];

        if (!!dataItem.type && dataItem.type.length > 0) {
          dataItem.selectedType = dataItem.type.map(x => x.dedId);
        }

        grid.editRow(rowIndex);
      });
    }
  }

  editRowData(data: any) {
    data.dataItem.selectedType = [];

    if (!!data.dataItem.type && data.dataItem.type.length > 0) {
      data.dataItem.selectedType = data.dataItem.type.map((x: {
        dedId: any;
      }) => x.dedId);
    }

    data.sender.editRow(data.rowIndex);
  }

  UpdateRowDataDist(data: any) {
    if (this.formGroupDist.valid) {
      this.saveCurrentDistribution();
      data.sender.closeRow(data.rowIndex);
    }
  }

  UpdateRowData(input: any) {
    if (input.dataItem.quantity == undefined || input.dataItem.quantity == null || input.dataItem.quantity.toString() == "" || input.dataItem.quantity <= 0) {
      this.notificationService.showToast("No of Copies is required", "Warning");
      return;
    } else if (input.dataItem.category == undefined || input.dataItem.category == null || input.dataItem.category.toString() == "") {
      this.notificationService.showToast("Category is required", "Warning");
      return;
    } else if (input.dataItem.type == undefined || input.dataItem.type == null || input.dataItem.type.toString() == "") {
      this.notificationService.showToast("Type is required", "Warning");
      return;
    } else {
      input.sender.closeRow(input.rowIndex);
    }
  }

  cancelRowDataDist(data: any) {
    data.sender.closeRow(data.rowIndex);
  }

  onCategoryChange(val: any) {
    this.formGroupDist.get('category')?.setValue(val.additionalValues.additionalValues);
  }

  onValueChange(val: any, fieldName: string, dataItem: any) {
    if (fieldName.toLocaleLowerCase() == 'quantity') {
      var data: any = this.documentViewList.filter(item => item.document_No.toLocaleLowerCase() == dataItem.document_No.toLocaleLowerCase());
      if (data)
        data[0].quantity = val.target.value;
    } else if (fieldName.toLocaleLowerCase() == 'category') {
      var data: any = this.documentViewList.filter(item => item.document_No.toLocaleLowerCase() == dataItem.document_No.toLocaleLowerCase());
      if (data) {
        data[0].category = val.additionalValues.additionalValues;
        data[0].selectedCategory = data[0].category.dedId;
      }
    } else if (fieldName.toLocaleLowerCase() == 'type') {
      var data: any = this.documentViewList.filter(item => item.document_No.toLocaleLowerCase() == dataItem.document_No.toLocaleLowerCase());
      if (data) {
        data[0].type = val.emittingList.map((x: {
          additionalValues: any;
        }) => x.additionalValues);
        data[0].selectedType = data[0].type.map((x: {
          dedId: any;
        }) => x.dedId);
      }
    } else if (fieldName.toLocaleLowerCase() == 'remarks') {
      var data: any = this.documentViewList.filter(item => item.document_No.toLocaleLowerCase() == dataItem.document_No.toLocaleLowerCase());
      if (data)
        data[0].remarks = val.target.value;
    }
    this.documentUpdateList = this.documentViewList;
  }

  onTypeChange(event: any, gridType?: string, dataItem?: any) {
    if (!!event) {
      if (gridType == "distribution") {
        if (event.emittingList.length > 0) {
          this.formGroupDist.get('type').setValue(event.emittingList.map((x: {
            additionalValues: any;
          }) => x.additionalValues));
        }
      }
    }
  }

  public remarkChange(value: any): void {
    this.formGroupDist.get('remarks').setValue(value.target.value);
  }

  public qtyChange(value: any): void {
    this.formGroupDist.get('quantity').setValue(value.target.value);
  }

  private getTransmittalMembers(members: IReceiverDetails[]): ITransmittalMemberModel[] {
    let _refmem = members.map(x => {
      if (this.masterMembers.some(y => y.memberId == x.member_Id)) {
        let _obj;
        let member: ITransmittalMemberModel;

        _obj = this.masterMembers.filter(y => y.memberId == x.member_Id)[0];

        member = {
          memberId: _obj ? x.member_Id : null,
          memberName: _obj ? x.member_Name : null,
          memberShortName: _obj ? _obj.memberShortName : "",
          eMailId: _obj ? _obj.eMailId : "",
          staffPSNo: _obj ? _obj.staffPSNo : "",
          mobileNo: _obj ? _obj.mobileNo : "",
          groupBy: x.receiver_Group
        };
        return member;
      }
    });
    return _refmem.filter(value => value != undefined);
  }

  previewTransmittal() {
    if (this.messageGroupForm.valid && this.transmittalForm.valid && this.messageContentForm.valid && this.dynamicForm.value.valid) {
      if (this.distributionList.length == 0) {
        this.notificationService.showToast("Distribution List Cannot be Empty", "Warning");
        return;
      }
      let findEmptyfields: any;
      findEmptyfields = this.distributionList.filter((data, index) => {
        if (!data.type || !data.category || !data.quantity) {
          return data;
        }
      });
      if (findEmptyfields.length > 0) {
        this.editRowDynamic(findEmptyfields[0]);
        return;
      }

      if (this.documentList.length == 0) {
        this.notificationService.showToast("No Documents Attached", "Warning");
        return;
      }
      let findocEmptyfields: any;
      findocEmptyfields = this.documentViewList.filter((data, index) => {
        if (!data.type || !data.category || !data.quantity) {
          return data;
        }
        return;
      });
      if (findocEmptyfields.length > 0) {
        this.editDocRowDynamic(findocEmptyfields[0]);
        return;
      }
      if (this.documentViewList && this.documentViewList.some(x => !x.isAttachemtUploded)) {
        this.notificationService.showToast("Every document should have at least one attachment", "Warning");
        return;
      }
      this.createTransmittalCoverSheet();
    } else {
      this.notificationService.showPopup("Mandatory fields are missing", "Warning");
      this.formMarkAsTouched(this.dynamicForm.form);
      this.formMarkAsTouched(this.messageGroupForm);
      this.formMarkAsTouched(this.transmittalForm);
      this.formMarkAsTouched(this.dynamicForm.form);
    }
  }

  formMarkAsTouched(form: FormGroup) {
    if (!form.valid)
      Object.keys(form.controls).forEach(key => {
        form.get(key)?.markAsTouched();
      });
  }

  GetWorkFlowStatus() {
    if (this.data.WorkflowTemplateDetails)
      if (this.data.WorkflowTemplateDetails.workflowStatus && this.data.WorkflowTemplateDetails.workflowStatus.some((x: {
        is_Show_Attachment_In_DTN: boolean;
      }) => x.is_Show_Attachment_In_DTN == true)) {
        this.is_Show_Attachment_In_DTN = true;
        this.task_id_list = this.data.WorkflowTemplateDetails.workflowStatus.filter((x: {
          is_Show_Attachment_In_DTN: boolean;
        }) => x.is_Show_Attachment_In_DTN == true).map((y: {
          task_Id: any;
        }) => y.task_Id).join();
      }
  }

  reSet() {
    this.messageGroupForm.reset();
    this.messageContentForm.reset();
    this.MessageId = 0;
    this.messageList = [];
    this.fromList = [];
    this.toList = [];
    this.ccList = [];
    this.bccList = [];
    this.datevalue = new Date(this.getDateFormat());
    this.RespondOn = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
    this.transmittalFormat = 'Transmittal';
    this.numFormat = 'Auto';
    this.readonly = true;
    this.responseRequired = 'No';
    this.messageGroupForm.controls['txtNoOfDays'].setValue(0);
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.getSignatureList();
    this.getElementDetails("Message Category");
    this.getElementDetails("Copy Type");
    this.selectedCategory = null;
    this.selectedTransmittalType = null
    this.selectedTo = null;
    this.selectedFrom = null;
    this.distributionList = [];
    this.ccMembers = [];
    this.ccFormMembers.updateValueAndValidity();
    this.ccFormMembers.setValue([]);
    this.resetCcMemberFilter();
  }

  public ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }


  public clickLocalAttachment() {
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: { projectId: this.projectId, msgId: -1, libraryName: FileUploadLibrary.Communication, createdBy: this.memberId, documents: [{ value: -1, text: this.messageNo, revisionNo: "" }], isEditable: false },
    });
    dialog.componentInstance.onUploadFinished.subscribe(res => {
      let fileName: string = res.fileName;
      let fileExtn: string = fileName.substring(fileName.lastIndexOf(".") + 1);
      this.attachmentsList.push({ fileId: -1, fileName: fileName.substring(0, fileName.lastIndexOf(".")), fileExtension: fileExtn, fileSize: res.fileSize });
    });
  }


  deleteFile(rowIndex: any) {
    this.notificationService.showPopup('Are you sure to delete', 'Confirm').then(data => {
      if (data == 'yes') {
        let fileDetails = this.attachmentsList[rowIndex];
        this._fileService.DeleteFile({ libraryNumber: 4, fileId: fileDetails.fileId, fileName: fileDetails.fileName + '.' + fileDetails.fileExtension }).subscribe(res => {
          this.attachmentsList.splice(rowIndex, 1);
        });
      }
    });

  }
}